<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<h1 class="chapter-number">RULE #2</h1>
<h1 class="chapter-title">Don't Assume You<br/> Can Replace Your Wealth</h1>
<p class="cotx">If risky investments turn out badly and you lose everything you have, you might be able to earn it all back again. But don't count on it.</p>
<p>Yes, you know far more now than when you started your career, but success always depends on conditions you don't control. And those conditions are constantly changing. Markets change, technology changes, the competition changes, consumer tastes change, and laws and regulations change.</p>
<p>You earned your wealth because your talent and effort harmonized with the circumstances in which you found yourself. But the world won't stand still for you or repeat itself when you need it to.</p>
<p>As time passes, government finds new ways to interfere with your business, your profession, and your life. Expanding regulations and the litigation explosion combine to make businesses much more vulnerable today to surprises and sudden disasters. And advances in technology change the demand for your products or service.</p>
<p>So assume that what you have now is irreplaceable, that you could never earn it again—even if you suspect you could.</p>
<p>Recognize, too, that without prudence whatever wealth you've accumulated is vulnerable to the same kinds of surprises—litigation, regulation, investigation, market setbacks, changing tastes, or just plain misjudgment. So you need to find a way to protect your savings from every eventuality—a task that, fortunately isn't as daunting as it might seem.</p>
<p>You're violating Rule #2 any time you think it's okay to go for broke with the savings you're counting on for the future— or when you treat your wealth with anything other than the utmost respect.</p>
<p>Protecting what you have requires setting up an investment program whose first priority is to preserve what you've worked for—making sure you don't take chances with the part of your wealth that's precious to you.</p>
<p>No matter how much or little you have now, it's possible to assure that you'll never lose it—as we'll see in Rule #11.</p>
<p>But the first step is to recognize how precious your wealth is, and resolve to say “No!” to any proposition that asks you to risk losing it.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?754c2b22